<template>
  <div class="schedule-final">
    <Toolbar class="schedule-final__toolbar" title-tag="h2" color="3">
      <template #title>
        <span class="schedule-final__toolbar-text">Национальный финал</span>
      </template>
      <template #default>
        <div class="schedule-final__date">
          <span class="schedule-final__toolbar-text">6 марта</span>
        </div>
      </template>
    </Toolbar>
    <div class="schedule-final__table">
      <ScheduleFinalTable />
    </div>
    <img
      class="schedule-final__players"
      src="~@/assets/images/other/schedule-mans.png"
      alt="Хоккеисты"
    />
  </div>
</template>

<script>
import { Toolbar } from "@/components/ui/toolbar/";
import ScheduleFinalTable from "./ScheduleFinalTable";

export default {
  components: {
    Toolbar,
    ScheduleFinalTable
  }
};
</script>

<style lang="scss">
.schedule-final {
  /* margin-top: 80px; */
  margin-top: 50px;
  background-color: #fff;

  &__toolbar {
    margin-bottom: 30px;
  }
  &__date {
    margin-left: auto;
    white-space: nowrap;
  }
  &__toolbar-text {
    font-size: 40px;
    text-transform: uppercase;
    color: colors(text-3);
    font-weight: fw(bold);
    font-style: italic;
    font-family: fonts(main);
  }

  &__table {
    position: relative;
  }

  &__players {
    display: block;
    margin: -80px auto 0;
    max-width: 100%;
    position: relative;
    z-index: 2;
    pointer-events: none;
  }

  @include breakpoint("md-and-down") {
    &__toolbar-text {
      font-size: 30px;
    }

    .toolbar {
      &__title {
        padding: 15px 25px;
      }
      &__content {
        padding-top: 0;
      }
    }
  }

  @include breakpoint("sm-and-down") {
    &__date {
      margin-left: 0;
    }

    &__players {
      margin-top: -70px;
    }
  }

  @include breakpoint("xs-only") {
    &__players {
      margin-top: -35px;
    }
  }
}
</style>
